import axios from 'axios';
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import env from '../../config/env';

function AssociatedAccount({ data }) {
  const [isHovered, setIsHovered] = useState(false);

  const [PermisConduire, setPermisConduire] = useState(data?.PermisConduire);
  const [PieceIdentite, setPieceIdentite] = useState(data?.PieceIdentite);

  useEffect(() => {
    setPermisConduire(data?.PermisConduire);
    setPieceIdentite(data?.PieceIdentite);
  }, [data]);

  useEffect(() => {
    let save = async () => {
      try {
        if (data) {
          await axios.put(`${env.baseUrlApi}/api/users/` + data?.id, {
            PermisConduire: PermisConduire == 1 ? 1 : 0,
            PieceIdentite: PieceIdentite == 1 ? 1 : 0,
          });
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    save();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PermisConduire, PieceIdentite]);

  // Conservé tel quel (non utilisé dans l'UI actuelle)
  // eslint-disable-next-line no-unused-vars
  function handleApprouver() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.put(`${env.baseUrlApi}/api/users/` + data?.id, {
          verified: '1',
        });
        if (responseOption.data) {
          toast.success("L'utilisateur a été bien approuvé. Elle est maintenant en ligne");
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }

  return (
    <>
      <ToastContainer />

      <div className="mc-gs-card">
        <div className="mc-gs-card-head">
          <h2 className="mc-gs-card-title">Sécurité et connexion</h2>

          <div className="mc-gs-actions">
            {isHovered ? (
              <button
                type="button"
                className="mc-btn mc-btn--ghost mc-btn--sm"
                onClick={() => setIsHovered(false)}
              >
                Annuler
              </button>
            ) : (
              <button
                type="button"
                className="mc-btn mc-btn--secondary mc-btn--sm"
                onClick={() => setIsHovered(true)}
              >
                <i className="bi bi-pencil" aria-hidden="true"></i>
                Modifier
              </button>
            )}
          </div>
        </div>

        <div className="mc-gs-group">
          <h3 className="mc-gs-group-title">Associer des comptes</h3>
          <div className="mc-gs-btn-row">
            <button type="button" className="mc-btn mc-btn--secondary">
              <i className="bi bi-google" aria-hidden="true"></i>
              Associer votre compte Google
            </button>
            <button type="button" className="mc-btn mc-btn--secondary">
              <i className="bi bi-facebook" aria-hidden="true"></i>
              Associer votre compte Facebook
            </button>
          </div>
        </div>

        <div className="mc-gs-group">
          <h3 className="mc-gs-group-title">Mise à jour de votre email</h3>
          <div className="mc-gs-fields mc-gs-fields--one">
            <div>
              <label className="mc-field-label" htmlFor="gs-new-email">
                Email
              </label>
              <input
                id="gs-new-email"
                className="mc-input"
                type="email"
                autoComplete="email"
                disabled={!isHovered}
              />
            </div>
            <div>
              <label className="mc-field-label" htmlFor="gs-new-email-confirm">
                Confirmer votre email
              </label>
              <input
                id="gs-new-email-confirm"
                className="mc-input"
                type="email"
                autoComplete="email"
                disabled={!isHovered}
              />
            </div>
          </div>
          <button type="button" className="mc-btn mc-btn--secondary mc-gs-submit">
            Mettre à jour l'email
          </button>
        </div>

        <div className="mc-gs-group">
          <h3 className="mc-gs-group-title">Mise à jour de votre mot de passe</h3>
          <div className="mc-gs-fields mc-gs-fields--one">
            <div>
              <label className="mc-field-label" htmlFor="gs-pwd-current">
                Mot de passe actuel
              </label>
              <input
                id="gs-pwd-current"
                className="mc-input"
                type="password"
                autoComplete="current-password"
                placeholder="Mot de passe actuel"
                disabled={!isHovered}
              />
            </div>
            <div>
              <label className="mc-field-label" htmlFor="gs-pwd-new">
                Nouveau mot de passe
              </label>
              <input
                id="gs-pwd-new"
                className="mc-input"
                type="password"
                autoComplete="new-password"
                placeholder="Nouveau mot de passe"
                disabled={!isHovered}
              />
            </div>
            <div>
              <label className="mc-field-label" htmlFor="gs-pwd-confirm">
                Confirmer votre mot de passe
              </label>
              <input
                id="gs-pwd-confirm"
                className="mc-input"
                type="password"
                autoComplete="new-password"
                placeholder="Confirmer votre mot de passe"
                disabled={!isHovered}
              />
            </div>
          </div>
          <button type="button" className="mc-btn mc-btn--secondary mc-gs-submit">
            Mettre à jour le mot de passe
          </button>
        </div>
      </div>
    </>
  );
}

export default AssociatedAccount;
